import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { HelperService } from '../../../shared/helperService';

@Injectable({
    providedIn: 'root'
})
export class AuthAdminGuard implements CanActivate {
  constructor(private helperService: HelperService, private router: Router) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (! this.helperService.isAdminUser) {
      // this.helperService.navigationUrl = state.url;
      // TODO: For Unauthorized redirect
      this.helperService.routeNavigate('login');
      return false;
    } else {
      return true;
    }
  }
}
